module.exports = __webpack_public_path__ + "img/6H.13fcb954.png";